import React from "react";

import { PensionData } from "../../interfaces/DTO/mislaka_xml_pension_models";

import {
  formatPolicyEmploymentStatus,
  formatExternalCoverage,
  formatPensionPlanType,
  formatPensionRegulationType,
  formatPensionMembershipStatus,
  formatYieldGuaranteeType,
  formatTikun190Option,
  formatInsuranceCoverageType,
  formatMortgageInsurance,
  formatDesignatedBondEligibility,
} from "../../utils/enumFormatter";
import { DataRowsDisplay } from "../../shared/UIParts/DataRowsDisplay";

interface PensionDataDisplayProps {
  pensionData: PensionData;
}

const PensionDataDisplay: React.FC<PensionDataDisplayProps> = ({ pensionData }) => {
  if (!pensionData) return null;

  const rows = [
    { label: "סטטוס תעסוקתי", value: formatPolicyEmploymentStatus(pensionData.employment_status) },
    { label: "כיסוי חיצוני", value: formatExternalCoverage(pensionData.external_coverage) },
    { label: "סוג קרן פנסיה", value: formatPensionPlanType(pensionData.pension_plan_type) },
    { label: "רגולציה פנסיונית", value: formatPensionRegulationType(pensionData.pension_regulation_type) },
    { label: "מעמד העמית", value: formatPensionMembershipStatus(pensionData.pension_membership_status) },
    { label: "כולל זכאות להבטחת תשואה", value: formatDesignatedBondEligibility(pensionData.is_designated_bond_eligible) },
    { label: "שיעור אג\"ח מיועדות", value: pensionData.designated_bond_percentage?.toString() },
    { label: "הבטחת תשואה שלא באמצעות אג\"ח", value: formatYieldGuaranteeType(pensionData.yield_guarantee_type) },
    { label: "תיקון 190", value: formatTikun190Option(pensionData.tikun_190_option) },
    { label: "כיסוי ביטוחי", value: formatInsuranceCoverageType(pensionData.insurance_coverage_type) },
    { label: "ביטוח משכנתא", value: formatMortgageInsurance(pensionData.mortgage_insurance) },
    { label: "תאריך תחילת ריסק זמני", value: pensionData.start_date_temporary_risk },
    { label: "תום תוקף ריסק זמני", value: pensionData.end_date_temporary_risk },
    { label: "תאריך אחרון למבוטח משופר", value: pensionData.last_improved_insured_date },
    { label: "תאריך סיום הבטחת תשואה", value: pensionData.yield_guarantee_end_date },
  ];

  return (
    <DataRowsDisplay
      title={`פרטי פנסיה ${formatPensionPlanType(pensionData.pension_plan_type)}`}
      rows={rows}
    />
  );
};

export default PensionDataDisplay;
